<template>
  <div>
    <div class="entertain-title">招待费申请</div>
    <a-descriptions bordered size="small" :column="2">
      <a-descriptions-item>
        <div slot="label" class="center">申请人</div>
        <div>{{ detail.extra.userName }}</div>
      </a-descriptions-item>

      <a-descriptions-item :span="1">
        <div slot="label" class="center">申请部门</div>
        <div>{{ detail.extra.deptName }}</div>
      </a-descriptions-item>

      <a-descriptions-item :span="2">
        <div slot="label" class="center">招待时间</div>
        <div>{{ detail.extra.entertainTime | dateFormat("YYYY-MM-DD") }}</div>
      </a-descriptions-item>

      <a-descriptions-item>
        <div slot="label" class="center">招待地点</div>
        <div>{{ detail.extra.entertainLocation === "inside" ? "院内" : detail.extra.entertainLocation === "outside" ? "院外" : "—" }}</div>
      </a-descriptions-item>

      <a-descriptions-item>
        <div slot="label" class="center">招待类型</div>
        <div><DataDictFinder dictType="entertainType" :dictValue="detail.extra.entertainType" /></div>
      </a-descriptions-item>

      <a-descriptions-item>
        <div slot="label" class="center">招待对象</div>
        <div>{{ detail.extra.entertainObject }}</div>
      </a-descriptions-item>

      <a-descriptions-item>
        <div slot="label" class="center">对方人数</div>
        <div>{{ detail.extra.guestCount }}</div>
      </a-descriptions-item>

      <a-descriptions-item>
        <div slot="label" class="center">我方人数</div>
        <div>{{ detail.extra.ourCount }}</div>
      </a-descriptions-item>
      <a-descriptions-item>
          <div slot="label" class="center">外部工作人员人数</div>
          <div>{{ detail.extra.staffCount }}</div>
          <div style="color: #8f8f8f; font-size: 12px; line-height: 1.5; margin-top: 4px;">含司机等辅助人员</div>
      </a-descriptions-item>
      <a-descriptions-item>
        <div slot="label" class="center">总体预算(含酒水)(元)</div>
        <div>{{ detail.extra.totalBudget }}</div>
      </a-descriptions-item>

      <a-descriptions-item>
          <div slot="label" class="center">是否领用酒水</div>
          <div>{{ detail.extra.needAlcohol === "1" ? "是" : "否" }}</div>
      </a-descriptions-item>

      <a-descriptions-item>
        <div slot="label" class="center">人均预算(元)</div>
        <div style="color: #1890ff">{{ perCapitaBudget }}</div>
      </a-descriptions-item>

      <a-descriptions-item>
          <div slot="label" class="center">可报销餐费(元)</div>
          <div style="color: #1890ff">{{ reimbursableBudget  || '0.00' }}</div>
      </a-descriptions-item>

      <a-descriptions-item>
        <div slot="label" class="center">酒水预算(元)</div>
        <div>
          <div>{{ detail.extra.alcoholBudget }}</div>
          <div style="color: #f5222d; font-size: 12px; line-height: 1.5; margin-top: 4px;">总体预算金额包含酒水预算金额</div>
        </div>
      </a-descriptions-item>

      <a-descriptions-item :span="2">
        <div slot="label" class="center">事由</div>
        <div>{{ detail.extra.remarks }}</div>
      </a-descriptions-item>
    </a-descriptions>

    <Table />

    <div class="rule-box">
      <div class="rule-title">业务关系及招待事由</div>
      <div class="rule-sub">我方人数：</div>
      <div class="rule-item">商务招待:招待对象在5人以内的，陪餐人数不得超过5人;招待对象超过5人的，新增陪餐人数不得超过新增招待对象人数的三分之一，自助餐除外。</div>
      <div class="rule-item">内部业务招待及其他公务招待:招待人数在10人以内的，陪餐人数不得超过3人;招待人数超过10人的，不得超过招待人数的三分之一。</div>
      <div class="rule-sub" style="margin-top: 8px;">费用预算：</div>
      <div class="rule-item">重要商务招待：每次人均不得超过500元（含酒水、饮料）</div>
      <div class="rule-item">一般商务招待：每次人均不得超过300元（含酒水、饮料），不得提供香烟和高档酒水</div>
      <div class="rule-item">其他公务：工作餐人均不得超过150元/次（不得提供香烟和酒水）</div>
      <div class="rule-item">内部业务招待：工作餐重要级人均不得超过150元/天，一般级人均不得超过130元/天，不得提供香烟，不上酒。</div>
      <div class="rule-item">客方工作人员（含司机）工作餐：人均不得超过50元/次</div>
      <div class="rule-divider"></div>
      <div class="rule-item">商务招待酒水实行集中采购，内部领用，业务招待费中不单独报销酒水费用。</div>
      <div class="rule-item">总体预算金额包含酒水预算金额</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Table from "./table.vue";
export default {
  components: {
    Table,
  },
  filters: {
    dateFormat(val, format) {
      if (!val) return '—';
      return moment(val).format(format || 'YYYY-MM-DD');
    },
  },
  computed: {
    ...mapState("approval", ["detail"]),

    perCapitaBudget() {
      const total = this.detail.extra.totalBudget;
      const guest = this.detail.extra.guestCount;
      const our = this.detail.extra.ourCount;
      const staff = this.detail.extra.staffCount || 0;
      if (total != null && guest != null && our != null && (parseInt(guest) + parseInt(our)) > 0) {
        return ((parseFloat(total) - parseInt(staff) * 50) / (parseInt(guest) + parseInt(our))).toFixed(2);
      }
      return '—';
    },

    // 可报销餐费 = 总体预算 - 酒水预算
    reimbursableBudget() {
      const total = this.detail.extra.totalBudget;
      const alcohol = this.detail.extra.alcoholBudget;
      if (total != null) {
        return (parseFloat(total) - parseFloat(alcohol || 0)).toFixed(2);
      }
      return '—';
    },
  },
};
</script>

<style lang="less" scoped>
.entertain-title {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
  text-align: center;
}

.rule-box {
  margin-top: 24px;
  padding: 16px 20px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.rule-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.rule-item {
  font-size: 12px;
  color: #666;
  line-height: 24px;
}

.rule-sub {
  font-size: 13px;
  color: #333;
  font-weight: 500;
  line-height: 24px;
}

.rule-divider {
  height: 1px;
  background: #e8e8e8;
  margin: 8px 0;
}
</style>
